module.exports = __webpack_public_path__ + "img/rentini-pack.a64522fc.png";